export class EffectLog {
  constructor({ id = Number.NaN, dateCreated = null, author = null } = {}) {
    this.id = id;
    this.dateCreated = dateCreated ? new Date(dateCreated) : new Date();
    this.author = author;
  }
}
